<template>
  <BaseCell :align="align">
    <div class="multi-risk-chip">
      <span
        v-for="(riskItem, index) in risks"
        :key="index"
        class="multi-risk-chip__item"
      >
        <div
          v-if="bulletColor[riskItem.value]"
          :style="getBulletStyle(riskItem)"
          class="multi-risk-chip__bullet"
        />
        {{ riskItem.label }}
      </span>
    </div>
  </BaseCell>
</template>

<script setup lang="ts">
import { BaseCell } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Risk {
  label: string;
  value: string;
}

interface Props {
  risks: Risk[];
  align?: string;
}

const { risks } = withDefaults(defineProps<Props>(), {
  align: 'right'
});

const bulletColor: { [key: string]: NebraskaColors } = {
  LOW: NebraskaColors.riskLow,
  MEDIUM: NebraskaColors.riskMedium,
  HIGH: NebraskaColors.riskHigh
};

function getBulletStyle(risk: Risk) {
  return { backgroundColor: bulletColor[risk.value] };
}
</script>

<style lang="less" scoped>
.multi-risk-chip {
  display: inline-flex;
  flex-direction: row;
  gap: @size-spacing-x150;
  justify-content: flex-end;
  flex-wrap: wrap;

  &__item {
    .text-p-6();
    background-color: @background-tertiary;
    padding: @size-spacing-x150 @size-spacing-x150;
    display: inline-flex;
    align-items: center;
    border-radius: @size-radius-x100;
    white-space: nowrap;
  }

  &__bullet {
    min-width: 6px;
    min-height: 6px;
    border-radius: @size-radius-x200;
    display: inline-block;
    margin-right: @size-spacing-x150;
  }
}
</style>
